import cx from 'classnames';

import Render from 'components/render';
import routes from 'constants/routes';
import i18n from 'i18n/config';
import {
  referralBonusFormattedInINRSelector,
  referralBonusFormattedInUSDSelector,
  referralBonusSelector,
} from 'selectors/referralBonusSelector';
import { useAppSelector } from 'storeHooks';

import styles from './indianWallet.module.scss';
import TooltipWrapper from './TooltipWrapper';

const referralCommissionLabel = i18n.t('headerFooter:header.wallet.referralWallet');
const referralCommissionTooltip = i18n.t(
  'headerFooter:header.wallet.referralCommissionTooltip'
);
const referralCommissionLink = i18n.t(
  'headerFooter:header.wallet.referralCommissionLink'
);

const TooltipBody = () => {
  return (
    (<div className={styles.tooltipBody} data-palette="TooltipBody">
      <span>{referralCommissionTooltip}</span>
      <a
        href={`/app${routes.account.withdrawalReferralWallet}`}
        data-testid="know-more"
        className={styles.referralCommissionLink}
      >
        {referralCommissionLink}
      </a>
    </div>)
  );
};

const ReferralCommission = ({
  showAmount,
  className = '',
}: {
  showAmount: boolean;
  className?: string;
}) => {
  const referralBonusFormattedInUSD = useAppSelector(referralBonusFormattedInUSDSelector);
  const referralBonusFormattedInINR = useAppSelector(referralBonusFormattedInINRSelector);
  const referralBouns = useAppSelector(referralBonusSelector);

  const showReferralBonus = referralBouns && Number(referralBouns) > 0;

  return (
    <Render when={showReferralBonus}>
      <div
        className={cx(
          styles['label-value-container'],
          styles.accountValueCollapsableButton,
          className
        )}
      >
        <div className={styles.label}>
          <TooltipWrapper title={referralCommissionLabel} body={<TooltipBody />} />
        </div>
        <div className={cx('flex-set flex--column', styles.value)}>
          <span className={styles.inr}>
            <Render when={showAmount} else="******">
              {referralBonusFormattedInINR}
            </Render>
          </span>
          <span className={styles.usd}>
            <Render when={showAmount} else="******">
              {referralBonusFormattedInUSD}
            </Render>
          </span>
        </div>
      </div>
    </Render>
  );
};

export { ReferralCommission };
